var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingApproval3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 326,
    viewBox: "0 0 247 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4265_9147)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 326,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.378 57.1585C144.318 54.4832 130.821 50.6472 118.072 51.0261C116.461 51.0738 115.035 52.1166 114.521 53.642C109.35 68.9698 123.916 72.8218 123.916 72.8218L127.978 89.0292C114.557 86.9514 109.619 110.839 128.738 113.635C147.858 116.431 156.74 124.904 170.067 121.53C176.871 119.808 182.002 108.312 172.697 104.024C170.827 103.163 169.886 101.056 170.56 99.112C175.993 83.4261 165.872 78.8977 159.018 77.599C155.782 76.9862 153.46 74.1281 153.454 70.8379L153.441 63.8796C153.436 61.0599 151.873 58.4774 149.378 57.1585",
    fill: "#5E3A30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.395 86.4907L134.826 102.146L117.703 122.472L168.196 114.9L159.856 105.523L144.366 85.3931L132.395 86.4907Z",
    fill: "#EFB87B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.939 133.731C106.211 133.727 106.483 133.712 106.754 133.691L118.217 114.03C121.82 107.851 127.824 103.44 134.801 101.847L126.88 113.741L133.395 126.667C133.395 126.667 126.052 136.813 123.865 140.559C121.897 143.929 116.81 148.932 113.032 149.929C111.088 150.443 109.008 150.381 106.99 150.236C106.966 144.195 105.639 138.538 103.342 133.68C104.206 133.729 105.073 133.746 105.939 133.731",
    fill: "#C962A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9424 148.924C92.8635 147.739 84.4766 143.634 79.9599 141.027C77.9467 139.865 71.4246 139.234 68.3253 125.964C65.2668 112.867 77.0646 117.669 79.2493 128.147C80.2842 125.96 79.9011 124.481 82.3084 124.218C85.0603 123.917 88.5541 129.709 90.9894 130.767C94.1188 132.127 97.4456 133.029 100.831 133.454C101.664 133.559 102.501 133.634 103.34 133.681C105.638 138.538 106.965 144.194 106.988 150.237C106.574 150.207 106.163 150.174 105.757 150.142C103.126 149.932 100.512 149.523 97.9424 148.924",
    fill: "#EFB87B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.631 151.188C122.732 149.363 122.661 147.536 122.411 145.725C121.515 139.254 119.627 121.023 124.958 110.623C126.723 107.18 130.252 104.191 134.577 102.156L131.151 109.669L148.61 99.395C157.25 99.9353 165.444 104.87 168.08 116.867C170.849 129.471 167.104 137.676 165.126 150.683C163.086 164.093 169.445 179.59 166.968 196.087C164.491 212.585 114.128 217.122 118.256 190.314C121.303 170.528 122.312 156.946 122.631 151.188",
    fill: "#D8E5E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.08 269.595L168.102 298.973C168.889 305.165 166.495 312.411 161.182 315.745L149.296 323.721C148.701 324.095 148.378 324.78 148.468 325.476L148.588 326.4L182.713 321.98L179.951 299.621L167.08 269.595Z",
    fill: "#EFB87B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.62 312.544C165.549 312.293 165.508 312.038 165.491 311.781C164.33 313.327 162.881 314.678 161.182 315.745L149.296 323.721C148.701 324.095 148.378 324.78 148.468 325.476L148.588 326.4L182.713 321.98L182.16 314.517C181.214 314.944 180.201 315.321 179.126 315.624C172.665 317.45 166.618 316.071 165.62 312.544",
    fill: "#F15961"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.2768 306.154C86.3065 305.896 86.3664 305.644 86.4483 305.399C84.7863 306.389 82.9319 307.088 80.9539 307.428L66.9252 310.289C66.2327 310.408 65.6726 310.918 65.4907 311.597L65.25 312.497L98.4934 321.377L100.823 314.266C99.7855 314.301 98.7045 314.264 97.5959 314.136C90.9248 313.369 85.8574 309.796 86.2768 306.154",
    fill: "#F15961"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4183 288.367L93.7481 295.783C92.6401 299.881 89.9805 303.297 86.4477 305.399C86.3658 305.644 86.3059 305.896 86.2762 306.154C85.8569 309.795 90.9242 313.369 97.5953 314.136C98.7039 314.263 99.785 314.301 100.823 314.266L108.09 290.55L95.4183 288.367Z",
    fill: "#EFB87B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.337 245.993L166.982 181.169L119.825 179.381C119.825 179.381 105.587 222.184 103.263 232.417C102.939 233.844 102.85 235.311 102.999 236.766L95.6055 288.297L108.183 290.754L124.619 241.456L138.791 209.444H141.77L149.87 242.693L149.989 242.711L149.87 242.751L168.084 298.426L180.136 300.78C180.291 293.66 171.248 252.121 171.337 245.993",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.684 58.2875C122.343 59.1589 119.242 64.7066 118.494 73.8909C118.329 75.0463 117.565 80.9113 118.265 82.009C118.965 83.1044 120.688 83.5552 122.029 83.4597C124.024 91.184 127.981 94.3705 133.04 93.8422C139.933 93.1223 145.406 86.2387 144.075 73.5274C143.005 63.3014 139.636 57.3524 130.684 58.2875",
    fill: "#EFB87B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.691 99.4014C157.3 99.9669 165.451 104.907 168.079 116.866C170.848 129.471 167.103 137.676 165.125 150.683C163.085 164.093 168.206 163.505 168.206 209.285C162.839 213.41 130.328 213.41 130.328 213.41C129.703 170.639 125.131 110.684 148.691 99.4014",
    fill: "#C962A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.324 190.594L176.051 167.629L169.066 125.703L167.074 122.467L172.621 170.154C165.327 173.945 153.685 172.575 145.501 169.995C140.447 168.401 137.306 163.366 138.048 158.123C138.687 153.609 139.538 148.327 140.631 142.875C144.529 123.444 149.684 110.741 155.539 106.139C157.511 104.589 159.747 103.995 161.874 104.324C161.874 104.324 159.734 102.206 157.365 101.53C156.056 101.956 154.783 102.653 153.554 103.619C141.656 112.971 136.16 146.735 134.176 162.774C134.098 162.66 134.058 162.595 134.058 162.595L131.825 186.254C130.883 196.396 138.702 205.228 148.893 205.531L163.958 205.98C170.307 206.169 175.776 202.134 177.71 196.451C178.349 194.573 178.52 192.568 178.324 190.594",
    fill: "#774331"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.717 135.469C173.383 119.268 166.922 110.718 160.073 104.067C158.938 105.85 157.755 107.602 156.589 109.365L154.018 131.851L164.642 146.213C163.97 146.507 162.506 147.373 160.569 148.42C165.431 151.971 168.871 157.263 169.923 163.344C171.485 162.514 173.257 161.386 175.114 159.863C182.297 153.964 184.549 143.934 180.717 135.469",
    fill: "#C962A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.723 154.417C146.798 154.112 149.813 153.21 152.688 152.108C153.614 151.753 158.081 149.959 160.57 148.42C165.432 151.971 168.871 157.263 169.924 163.344C166.451 165.19 164.018 165.568 164.018 165.568C161.67 166.421 152.679 167.66 150.515 167.849C148.521 168.024 146.688 168.165 145.177 168.16C138.912 168.138 135.625 164.571 135.199 160.282C134.773 155.992 138.743 154.911 143.723 154.417",
    fill: "#EFB87B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.164 60.9156C141.345 56.7759 125.972 56.7161 125.972 56.7161C125.972 56.7161 125.224 70.3389 139.199 77.2324C140.89 78.067 141.706 79.9982 141.126 81.7916C139.638 86.3827 140.063 91.0232 140.863 94.5249C141.626 97.8601 144.581 100.236 148.004 100.275C153.337 100.336 161.606 101.074 166.821 104.667C175.024 110.32 151.212 85.5173 149.164 60.9156",
    fill: "#5E3A30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7973 138.155H82.1259C83.0213 138.155 83.6192 137.43 83.4615 136.535L79.7077 115.268C79.5499 114.373 78.6964 113.648 77.8011 113.648H75.4719C73.852 113.753 74.1403 115.529 74.298 116.423L77.8901 136.535C78.0479 137.43 78.902 138.155 79.7973 138.155Z",
    fill: "#103541"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4265_9147"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 326,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApproval3);
export default __webpack_public_path__ + "static/media/PendingApproval3.1094c432eb7e38b2bf10351fe7ca100c.svg";
export { ForwardRef as ReactComponent };